import { render, staticRenderFns } from "./ProjectPanel.vue?vue&type=template&id=6a0c06af&"
import script from "./ProjectPanel.vue?vue&type=script&lang=js&"
export * from "./ProjectPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports